"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassNames = /** @class */ (function () {
    function ClassNames() {
        this.root = 'edd-root';
        this.rootOpen = 'edd-root-open';
        this.rootOpenAbove = 'edd-root-open-above';
        this.rootOpenBelow = 'edd-root-open-below';
        this.rootDisabled = 'edd-root-disabled';
        this.rootInvalid = 'edd-root-invalid';
        this.rootFocused = 'edd-root-focused';
        this.rootHasValue = 'edd-root-has-value';
        this.rootNative = 'edd-root-native';
        this.gradientTop = 'edd-gradient-top';
        this.gradientBottom = 'edd-gradient-bottom';
        this.head = 'edd-head';
        this.value = 'edd-value';
        this.arrow = 'edd-arrow';
        this.select = 'edd-select';
        this.body = 'edd-body';
        this.bodyScrollable = 'edd-body-scrollable';
        this.bodyAtTop = 'edd-body-at-top';
        this.bodyAtBottom = 'edd-body-at-bottom';
        this.itemsList = 'edd-items-list';
        this.group = 'edd-group';
        this.groupDisabled = 'edd-group-disabled';
        this.groupHasLabel = 'edd-group-has-label';
        this.groupLabel = 'edd-group-label';
        this.option = 'edd-option';
        this.optionDisabled = 'edd-option-disabled';
        this.optionFocused = 'edd-option-focused';
        this.optionSelected = 'edd-option-selected';
        Object.seal(this);
    }
    return ClassNames;
}());
exports.default = ClassNames;
//# sourceMappingURL=ClassNames.js.map